import React, { useState, useContext } from "react";
import styles from "./layout.module.css";
import Footer from "../footer";
import MenuButton from "../menuButton";
import { HashLink } from "react-router-hash-link";
import { LanguageContext } from "../../context/LanguageContext";
import Data from "../../assets/language/en.json";
import Select from "react-select";

const options = [
  {
    value: "eng",
    label: (
      <div className={styles.languageImage}>
        <img src="/assets/images/homepage/english.png" alt="logo" />
      </div>
    ),
  },
  {
    value: "rus",
    label: (
      <div className={styles.languageImage}>
        <img src="/assets/images/homepage/russia.jpg" alt="russia" />
      </div>
    ),
  },
  {
    value: "spn",
    label: (
      <div className={styles.languageImage}>
        <img src="/assets/images/homepage/spanish.png" alt="spain" />
      </div>
    ),
  },
];

const getSelectedLang = (lang) => {
  if (lang.value === "rus") return options[1];
  if (lang.value === "spn") return options[2];
  return options[0];
};

const Layout = ({ children, history }) => {
  const [showNavbar, setShowNavbar] = useState();
  const { data, language, setLanguage } = useContext(LanguageContext);

  const meta = data || Data;

  const HeaderLink = meta.footer.links[0];

  const handleNavbar = (e) => {
    e.preventDefault();
    setShowNavbar(!showNavbar);
  };

  const isActive = (path) => {
    const currentPathName = window.location.pathname + window.location.hash;

    return currentPathName === path;
  };

  return (
    <div className={styles.layoutWrapper}>
      <div className={styles.navbar}>
        <ul>
          <HashLink smooth to="/#AboutUs">
            <li
              className={`${styles.navlink} ${
                isActive("/#AboutUs") && `${styles.active}`
              }`}
            >
              {HeaderLink.aboutus}
            </li>
          </HashLink>
          <HashLink smooth to="/#whyus">
            <li
              className={`${styles.whyus} ${
                isActive("/#Whyus") && `${styles.active}`
              }`}
            >
              {HeaderLink.whyus}
            </li>
          </HashLink>
          <HashLink smooth to="/ourProducts#top">
            <li
              className={`${styles.navlink} ${
                isActive("/ourProducts#top") && `${styles.active}`
              }`}
            >
              {HeaderLink.products}
            </li>
          </HashLink>
          <HashLink smooth to="/#top">
            <li className={styles.desktopLogoWrap}>
              <img src="/assets/images/homepage/logo.svg" alt="logo" />
            </li>
          </HashLink>
          <HashLink smooth to="/supplier#top">
            <li
              className={`${styles.navlink} ${
                isActive("/supplier#top") && `${styles.active}`
              }`}
            >
              {HeaderLink.becomeaSupplier}
            </li>
          </HashLink>
          {/* <HashLink smooth to="/careers#top">
            <li
              className={`${styles.navlink} ${
                isActive("/careers#top") && `${styles.active}`
              }`}
            >
              {HeaderLink.careers}
            </li>
          </HashLink> */}
          <HashLink smooth to="/contact#top">
            <li
              className={`${styles.navlink} ${
                isActive("/contact#top") && `${styles.active}`
              }`}
            >
              {HeaderLink.contactus}
            </li>
          </HashLink>
          <HashLink smooth to="">
            <li className={styles.navlink}>
              <Select
                menuPosition="fixed"
                menuPlacement="auto"
                isSearchable={false}
                value={language.value ? getSelectedLang(language) : options[0]}
                onChange={(n, a) => setLanguage(n)}
                options={options}
              />
            </li>
          </HashLink>
        </ul>
      </div>

      <div className={styles.mobileNavbar}>
        <ul>
          <li className={styles.mobileNavlink}>
            <Select
              menuPosition="fixed"
              menuPlacement="auto"
              isSearchable={false}
              value={language.value ? getSelectedLang(language) : options[0]}
              onChange={(n, a) => setLanguage(n)}
              options={options}
            />
          </li>

          <li className={styles.logoWrap}>
            <HashLink smooth to="/#top">
              <img
                src="/assets/images/homepage/logo.svg"
                alt="logo"
                className={styles.etLogo}
              />
            </HashLink>
          </li>

          <li className={styles.menuWrap}>
            <div className={styles.menuButton} onClick={(e) => handleNavbar(e)}>
              <MenuButton />
            </div>
          </li>
        </ul>
      </div>

      {showNavbar ? (
        <div className={styles.navMenuMainWrap}>
          <ul>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/#AboutUs">
                {HeaderLink.aboutus}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/#whyus">
                {HeaderLink.whyus}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/ourProducts#top">
                {HeaderLink.products}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/#OurTeam">
                {HeaderLink.ourteam}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/careers#top">
                {HeaderLink.careers}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/supplier#top">
                {HeaderLink.becomeaSupplier}
              </HashLink>
            </li>
            <li onClick={(e) => handleNavbar(e)}>
              <HashLink smooth to="/contact#top">
                {HeaderLink.contactus}
              </HashLink>
            </li>
          </ul>
        </div>
      ) : (
        ""
      )}

      <main>{children}</main>

      <Footer />
    </div>
  );
};

export default Layout;
